/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RapportinoInvioDTO
 */
export interface RapportinoInvioDTO {
    /**
     * 
     * @type {number}
     * @memberof RapportinoInvioDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RapportinoInvioDTO
     */
    destinatari?: Array<string> | null;
}

/**
 * Check if a given object implements the RapportinoInvioDTO interface.
 */
export function instanceOfRapportinoInvioDTO(value: object): value is RapportinoInvioDTO {
    return true;
}

export function RapportinoInvioDTOFromJSON(json: any): RapportinoInvioDTO {
    return RapportinoInvioDTOFromJSONTyped(json, false);
}

export function RapportinoInvioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportinoInvioDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'destinatari': json['destinatari'] == null ? undefined : json['destinatari'],
    };
}

export function RapportinoInvioDTOToJSON(json: any): RapportinoInvioDTO {
    return RapportinoInvioDTOToJSONTyped(json, false);
}

export function RapportinoInvioDTOToJSONTyped(value?: RapportinoInvioDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'destinatari': value['destinatari'],
    };
}

